/**
 * BINDING COPY — the byte-exact footnote under the zone lap table on both
 * clients. Red is the attribution-culprit promise (never "slowest"); ↓ marks
 * the slowest displayed lap. A metric coverage note (braking zones: the
 * brake-point row's note) is appended after a middle dot when present.
 */
export function lapTableFootnote(coverageNote?: string | null): string {
  return `Red = laps outside the typical spread · ↓ slowest lap${
    coverageNote ? ` · ${coverageNote}` : ''
  }`
}
